export default __webpack_public_path__ + "static/media/bgGreen50x70.a65e66e1.jpg";